import { api } from "@/lib/axios"
import type { User } from "@/stores/auth-store"

interface ProfileResponse {
  status: number
  message: string
  data: User
}

export async function fetchProfile(): Promise<ProfileResponse> {
  const { data } = await api.get<ProfileResponse>("/accounts/get-me/")
  return data
}
